import React from 'react';
import classnames from 'classnames';
import { get } from 'helpers/utils';

const Item = ({
  styles,
  cells,
  index,
  item,
}) => (
  cells.map(({ keyName, name, renderField, nowrap, wrapText, onRender }) => {
    const value = get(item, renderField);
    return (
      <td
        key={keyName || name}
        className={classnames(styles.cell, {
          [styles.nowrap]: nowrap,
          [styles.wrapText]: wrapText,
        })}
      >
        {onRender ? onRender(item, value, index, renderField) : value}
      </td>
    );
  })
);

export default Item;
